import React, { Fragment } from "react";

import clsx from "clsx";
import { Link } from "react-router-dom";

import { Paper, List, ListItem, ListItemText } from "@material-ui/core";

import { connect } from "react-redux";

const Footer = (props) => {
  const { footerShadow, sidebarToggle, footerFixed } = props;
  return (
    <Fragment>
      <Paper
        square
        elevation={footerShadow ? 11 : 2}
        className={clsx("app-footer text-black-50", {
          "app-footer--fixed": footerFixed,
          "app-footer--fixed__collapsed": sidebarToggle,
        })}
      >
        <div className="app-footer--inner">
          <div className="app-footer--second">
            <span>BESC 3.0</span>
            Copyright © 2024, CNCC
          </div>
        </div>
      </Paper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  footerFixed: state.ThemeOptions.footerFixed,
  footerShadow: state.ThemeOptions.footerShadow,
  sidebarToggle: state.ThemeOptions.sidebarToggle,
});
export default connect(mapStateToProps)(Footer);
